import PropTypes from "prop-types";

import IconClose from "assets/svg/close.svg";

import styles from "./styles.module.css";

const TriggerAlert = ({ onClose }) => (
  <div className={styles.wrapper}>
    <div className={styles.triangle}></div>
    <div className={styles.contentWrapper}>
      <IconClose className={styles.closeIcon} onClick={() => onClose()} />
      <div className={styles.content}>
        <p className={styles.triggerAlertContent}>
          <span className={styles.contentBold}>Aramayı kaydet,</span> kriterlerine uygun
          <span className={styles.contentBold}> yeni ilanlar yayınlandığında </span>sana haber verelim.
        </p>
      </div>
    </div>
  </div>
);

TriggerAlert.propTypes = {
  onClose: PropTypes.func,
};

export default TriggerAlert;
